var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPitstopGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41463 0C1.52878 0 0 1.52845 0 3.41389V49.9281C0 51.8136 1.52878 53.342 3.41463 53.342H21.7745H23.6809L23.4714 51.4476C23.4301 51.0738 23.4043 50.6951 23.3946 50.312L23.3528 48.6479H21.6879H4.69512V4.6941H65.3049V48.6479H51.6416H49.9767L49.9349 50.312C49.9252 50.6951 49.8994 51.0738 49.8581 51.4476L49.6486 53.342H51.555H66.5854C68.4712 53.342 70 51.8136 70 49.9281V3.41389C70 1.52845 68.4712 0 66.5854 0H3.41463ZM36.6645 39.9434C31.1248 39.9434 26.634 44.4332 26.634 49.9717C26.634 55.5102 31.1248 60 36.6645 60C42.2042 60 46.695 55.5102 46.695 49.9717C46.695 44.4332 42.2042 39.9434 36.6645 39.9434ZM29.5697 11.6917H23.962V27.4597H18.3544L26.7658 36.9205L35.1773 27.4597H29.5697L29.5697 11.6917ZM46.04 36.9208V21.1528H51.6476L43.2362 11.6919L34.8247 21.1528H40.4323V36.9208H46.04Z",
    fill: "#C3CBD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitstopGrey);
export default __webpack_public_path__ + "static/media/Pitstop-grey.0ff8b4a41e60fdae1018826cac0599bc.svg";
export { ForwardRef as ReactComponent };